import { AlertErrorCircle, ChevronRight } from '@/assets/icons'
import { Toggle } from '@/components/toggle/Toggle'
import type { ToggleOption } from '@/components/toggle/types'
import { DEVICE_TYPE, useDeviceType } from '@/hooks/useDeviceType'
import { kPaxtonName } from '@/constants/constants-strings'
import type { ExternalStorageProvider } from '@/constants/constants-external-storage'
import type { DriveSourceViewMode } from '@/user_files/drive/types'
import { PROVIDER_COMPACT_DISPLAY_NAME, PROVIDER_ICON_COMPONENTS } from '@/user_files/external-storage/ProviderMeta'

type DmsSourceToggleProps = {
  /** The matter's synced provider, or the connected one when no folder is synced yet. Null only when the status failed to load. */
  provider: ExternalStorageProvider | null
  viewMode: DriveSourceViewMode
  onChangeViewMode: (mode: DriveSourceViewMode) => void
}

export function DmsSourceToggle({ provider, viewMode, onChangeViewMode }: DmsSourceToggleProps) {
  const providerLabel = provider ? PROVIDER_COMPACT_DISPLAY_NAME[provider] : 'Connected files'
  const ProviderIcon = provider ? PROVIDER_ICON_COMPONENTS[provider] : AlertErrorCircle
  const showLabels = useDeviceType() !== DEVICE_TYPE.MOBILE

  const options: [ToggleOption<DriveSourceViewMode>, ToggleOption<DriveSourceViewMode>] = [
    { value: 'external', label: providerLabel, icon: <ProviderIcon className={provider ? undefined : 'text-red-700'} /> },
    { value: 'matter', label: kPaxtonName, compactIcon: <img src="/images/paxton-favicon.png" alt="" className="object-contain" /> },
  ]

  return (
    <div className="flex shrink-0 items-center gap-3.5">
      <Toggle aria-label="File source" options={options} value={viewMode} onChange={onChangeViewMode} showLabels={showLabels} />
      <ChevronRight className="text-brand-neutral-600 w-5 h-5 shrink-0" aria-hidden="true" />
    </div>
  )
}
